export const pushData = (
  chartArr,
  date,
  count,
  data1 = 0,
  data2 = 0,
  data3 = 0
) => {
  switch (count) {
    case 3: {
      chartArr.push([
        date,
        data1,
        'point {  stroke-color: #fff; stroke-width: 1; }',
        data2,
        'point { stroke-color: #fff; stroke-width: 1; }',
        data3,
        'point { stroke-color: #fff; stroke-width: 1; }'
      ]);
      break;
    }
    case 2: {
      chartArr.push([
        date,
        data1,
        'point {  stroke-color: #fff; stroke-width: 1; }',
        data2,
        'point { stroke-color: #fff; stroke-width: 1; }'
      ]);
      break;
    }
    case 1: {
      chartArr.push([
        date,
        data1,
        'point {  stroke-color: #fff; stroke-width: 1; }'
      ]);
      break;
    }
    default: {
      chartArr.push(['', 0, 'point {  stroke-color: #fff; stroke-width: 1; }']);
    }
  }
};

export const emptyAreaChart = (chartArr, options) => {
  chartArr.push(['month', 'Total licenses', { type: 'string', role: 'style' }]);
  pushData(chartArr, '');
  options.pointSize = 0;
  options.vAxis.maxValue = 10;
  options.tooltip.trigger = 'none';
  options.colors = ['#fff'];
};

export const calcTrend = (digit1, digit2) => {
  if (digit1 === 0 && digit2 !== 0) {
    return 100;
  }
  if (digit1 === 0 && digit2 === 0) {
    return 0;
  } else {
    return +((digit2 / digit1 - 1) * 100).toFixed(0);
  }
};
